/**
 * Magnolia Kids · selector de packs en tarjetas (tema Crescendo). Markup y textos: snippets/mk-pack-selector.liquid.
 *
 * Cada tarjeta es una variante. Al elegirla se cambian los botones del selector nativo de Crescendo
 * (`variant-selects`, oculto): así el tema actualiza precio, fotos, URL y botón de compra. Al confirmarse el cambio nativo se publica la
 * selección con window.MK.select() para que cuotas y estimador de envío se sincronicen (mk-crescendo.js).
 *
 * Parte dependiente del tema, al final: coloca <template id="mk-pack-tpl"> antes de `variant-selects` y lo oculta.
 * Se carga desde snippets/mk-commerce-config.liquid, antes que mk-core.js: arranca en DOMContentLoaded.
 */
(function () {
  if (customElements.get('mk-pack-selector')) return;

  customElements.define('mk-pack-selector', class extends HTMLElement {
    connectedCallback() {
      this.opts = [].slice.call(this.querySelectorAll('.mk-pack__opt'));
      this.chips = [].slice.call(this.querySelectorAll('.mk-pack__chip'));
      this.umbral = Number(this.dataset.umbral) || 0;
      this.optionNames = this.readJson('[data-mk-options]') || [];
      this.allVariants = this.readJson('[data-mk-variants]') || [];
      this.packIndex = this.optionNames.length - 1;

      var inicial = this.querySelector('.mk-pack__opt.is-on') || this.opts.filter(function (o) { return !o.classList.contains('is-out'); })[0];
      var v = inicial && this.findById(inicial.dataset.variant);
      this.sel = v ? v.o.slice() : [];

      this.opts.forEach(function (o) { o.addEventListener('click', function () { this.onPack(o); }.bind(this)); }, this);
      this.chips.forEach(function (c) { c.addEventListener('click', function () { this.onChip(c); }.bind(this)); }, this);

      this.info = this.closest('product-info');
      this.onConfirmedChange = function (event) {
        if (event.data.sectionId === (this.info.dataset.originalSection || this.info.dataset.section)) this.syncFromNative();
      }.bind(this);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onConfirmedChange);
      }
      this.syncFromNative();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    syncFromNative() {
      var input = this.info && this.info.querySelector('product-form input[name="id"]');
      var v = input && this.findById(input.value);
      if (!v) return;
      this.sel = v.o.slice();
      this.variant = String(v.id);
      this.refreshRows();
      this.opts.forEach(function (o) {
        var selected = o.dataset.pack === v.o[this.packIndex];
        o.classList.toggle('is-on', selected);
        o.setAttribute('aria-checked', selected);
      }, this);
      this.chips.forEach(function (c) {
        var selected = c.dataset.value === v.o[Number(c.dataset.opt)];
        c.classList.toggle('is-on', selected);
        c.setAttribute('aria-checked', selected);
      });
      this.updateShipping(v.p);
      var detail = { pesos: v.p / 100, mode: 'variant', variantId: this.variant };
      if (window.MK) window.MK.select(detail);
      else { window.MKSelection = detail; document.dispatchEvent(new CustomEvent('mk:selection', { detail: detail })); }
    }

    readJson(sel) {
      try { return JSON.parse(this.querySelector(sel).textContent); } catch (e) { return null; }
    }
    money(cents) { return window.MK ? window.MK.fmt(cents / 100) : '$' + Math.round(cents / 100); }
    findById(id) { return this.allVariants.filter(function (v) { return String(v.id) === String(id); })[0]; }
    findBySel(sel) { return this.allVariants.filter(function (v) { return v.o.every(function (val, i) { return val === sel[i]; }); })[0]; }

    onChip(chip) {
      var j = Number(chip.dataset.opt);
      this.chips.filter(function (c) { return Number(c.dataset.opt) === j; }).forEach(function (c) {
        c.classList.toggle('is-on', c === chip);
        c.setAttribute('aria-checked', c === chip);
      });
      this.sel[j] = chip.dataset.value;
      this.refreshRows();
      var row = this.opts.filter(function (o) { return o.classList.contains('is-on'); })[0];
      if (!row || row.classList.contains('is-out')) row = this.opts.filter(function (o) { return !o.classList.contains('is-out'); })[0];
      if (row) this.onPack(row);
    }

    onPack(o) {
      if (!o || o.classList.contains('is-out')) return;
      this.opts.forEach(function (x) { x.classList.toggle('is-on', x === o); x.setAttribute('aria-checked', x === o); });
      this.sel[this.packIndex] = o.dataset.pack;
      var v = this.findBySel(this.sel);
      this.variant = v ? String(v.id) : o.dataset.variant;
      this.driveThemePicker();

    }

    // Recalcula precio, tachado y stock de cada pack para el color elegido.
    refreshRows() {
      var self = this;
      this.opts.forEach(function (o) {
        var s = self.sel.slice();
        s[self.packIndex] = o.dataset.pack;
        var v = self.findBySel(s);
        o.hidden = !v;
        if (!v) return;
        var ahorro = v.c > v.p ? v.c - v.p : 0;
        o.dataset.variant = v.id;
        o.dataset.final = v.p;
        o.classList.toggle('is-out', !v.a);
        if (v.a) o.removeAttribute('aria-disabled'); else o.setAttribute('aria-disabled', 'true');
        o.querySelector('.mk-pack__now').textContent = self.money(v.p);
        var was = o.querySelector('.mk-pack__was');
        was.textContent = self.money(v.c);
        was.hidden = !ahorro;
        var envio = self.dataset.envio;
        var partes = [o.dataset.desc, self.umbral && envio && v.p >= self.umbral ? envio : ''].filter(Boolean);
        var desc = o.querySelector('.mk-pack__desc');
        desc.textContent = partes.join(' · ');
        desc.hidden = !partes.length;
      });
    }

    // Cambia el selector nativo (radios o <select>) para que el tema actualice precio, fotos, URL y botón de compra.
    driveThemePicker() {
      var info = this.closest('product-info') || document;
      var picker = info.querySelector('variant-selects');
      if (!picker) return;
      var sel = this.sel;
      this.optionNames.forEach(function (name, j) {
        var val = sel[j];
        var radio = [].slice.call(picker.querySelectorAll('input[type="radio"]')).filter(function (r) { return r.name === name && r.value === val; })[0];
        if (radio) {
          if (!radio.checked) radio.click();
          return;
        }
        var select = [].slice.call(picker.querySelectorAll('select')).filter(function (s) { return s.name === name || (s.getAttribute('name') || '').indexOf(name) !== -1; })[0];
        if (select && select.value !== val) {
          select.value = val;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updateShipping(total) {
      var msg = this.querySelector('.mk-pack__ship-msg');
      var bar = this.querySelector('.mk-pack__bar-fill');
      if (!msg || !this.umbral) return;
      msg.textContent = total >= this.umbral
        ? 'Tu pack tiene despacho gratis a todo Chile'
        : 'Te faltan ' + this.money(this.umbral - total) + ' para despacho gratis';
      bar.style.width = Math.min(100, Math.round((total / this.umbral) * 100)) + '%';
    }
  });

  // --- Adaptador de Crescendo ---

  function mount() {
    var tpl = document.getElementById('mk-pack-tpl');
    var picker = document.querySelector('product-info variant-selects');
    if (!tpl || !picker) return;
    var html = tpl.innerHTML.trim();
    tpl.remove();
    if (!html) return;
    picker.closest('product-info').classList.add('mk-has-packs');
    picker.insertAdjacentHTML('beforebegin', html);
    picker.setAttribute('data-mk-hidden', '');
  }

  if (document.readyState === 'complete') mount();
  else document.addEventListener('DOMContentLoaded', mount);
})();
